import { styled, Box, Paper } from "@mui/material";
import { grey } from "@mui/material/colors";

export const Root = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(7),
})) as typeof Box;

export const StyledPaper = styled(Paper)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  width: "100%",
  minHeight: 200,
  margin: "1em auto",
  backgroundColor: grey[100],
  boxShadow: "none",
  borderRadius: 10,
}) as typeof Paper;

export const StyledWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  padding: theme.spacing(2),
  width: "100%",
})) as typeof Box;

export const StyledRoundWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
})) as typeof Box;

export const StyledRoundDescription = styled(Box)({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
}) as typeof Box;

export const StyledRound = styled(Box)(({ theme }) => ({
  ...theme.typography.h6,
})) as typeof Box;

export const StyledTime = styled(Box)(({ theme }) => ({
  ...theme.typography.caption,
})) as typeof Box;

export const StyledRoundPagination = styled(Box)(({ theme }) => ({
  display: "flex",
  height: "100%",
  padding: theme.spacing(1),
  alignSelf: "center",
  justifySelf: "flex-end",
  marginLeft: "auto",
})) as typeof Box;
